import { User } from 'src/app/core/model/user-model';
import { FoodModel } from '../object/diet-food-model';
import { foodUnitRatioArray } from './persoanl-response-model';

export class CookingStoryCategories {
  constructor(
    public statusCode: number,
    public success: boolean,
    public categories: CookingStoryCategorie[]
  ) {}
}
export class CookingStoryCategorie {
  constructor(
    public name: string,
    public tags: string[],
    public deleted: boolean,
    public verticalOrder: number,
    public horizontalOrder: number,
    public type: string,
    public selectImage: string,
    public deselectImage: string,
    public _id: string,
    public updatedAt: string,
    public createdAt: string
  ) {}
}
export class CookingStoryPageResponce {
  constructor(
    public statusCode: number,
    public message_id: number,
    public suggestion: cookingstorySuggest,
    public categories: cookingStoryPageCategories[]
  ) {}
}
export class cookingstorySuggest {
  constructor(
    public _id: string,
    public image: string,
    public name: string,
    public impressions: number,
    public likes: number
  ) {}
}
export class cookingStoryPageCategories {
  constructor(
    public name: string,
    public type: string,
    public _id: string,
    public ratio: string,

    public recipes: cookingStoryPageRecipe[]
  ) {}
}
export class cookingStoryPageRecipe {
  constructor(
    public _id: string,
    public image: string,
    public name: string,
    public impressions: number,
    public likes?: number
  ) {}
}
export class cookingStoryMoreCategorie {
  constructor(
    public count: number,
    public recipes: cookingStoryPageRecipe[],
    public statusCode: number
  ) {}
}
export class cookingStorySearchItem {
  constructor(
    public tags: string[],
    public _id: string,
    public name: string,
    public foods: CookingKitchenSearchFoods[]
  ) {}
}
export class CookingKitchenSearchFoods {
  constructor(
    public _id: string,
    public name: string,
    public unit: foodUnitRatioArray,
    public food?: FoodModel
  ) {}
}
export class cookingStoryKitchenSearchResponce {
  constructor(
    public message: string,
    public statusCode: number,
    public success: boolean,
    public list: cookingStorySearchItem[]
  ) {}
}
export class kitchenSearchItem {
  constructor(
    public food: string,
    public quickAdd: string,
    public amount: number,
    public unit: string,
    public unitDescription: string,
    public description: string,
    public expireDate?: Date,
    public name?: string,
    public foodUnitRatioArray?: foodUnitRatioArray[],
    public save?: boolean,
    public id?: string
  ) {}
}

export class shoppingListHomeItemResponce {
  constructor(
    public message: string,
    public statusCode: number,
    public success: boolean,
    public shoppingList: shoppingListItem[]
  ) {}
}
export class KitchenHomeItemResponce {
  constructor(
    public message: string,
    public statusCode: number,
    public success: boolean,
    public kitchen: kitchenItem[]
  ) {}
}
export class shoppingListItem {
  constructor(
    public quickAdd: string,
    public _id: string,
    public food: string | FoodModel,
    public groceryCategory: string,
    public user: string,
    public unit: string,
    public unitDescription: string,
    public description: string,
    public amount: number
  ) {}
}

export class kitchenItem {
  constructor(
    public quickAdd: string,
    public _id: string,
    public food: string | FoodModel,
    public groceryCategory: string,
    public user: string,
    public unit: string,
    public unitDescription: string,
    public description: string,
    public amount: number,
    public expireDate: number
  ) {}
}

export class groceryCategoryRespoce {
  constructor(
    public message: string,
    public statusCode: number,
    public success: boolean,
    public list: groceryCategoryList[],
    public count: number
  ) {}
}
export class groceryCategoryList {
  constructor(
    public tags: string[],
    public name: string,
    public deleted: boolean,
    public _id: string,
    public updatedAt: string,
    public createdAt: string
  ) {}
}
export class shoppingListItemInCategory {
  constructor(
    public _id: string,
    public tags: string[],
    public name: string,
    public foods: shoppingListItem[]
  ) {}
}
export class KitchenItemInCategory {
  constructor(
    public _id: string,
    public tags: string[],
    public name: string,
    public foods: kitchenItem[]
  ) {}
}
export class createKitchenItem {
  constructor(
    public food: string,
    public amount: number,
    public unit: string,
    public expireDate: number,
    public unitDescription: string,
    public description: string,
    public quickAdd?: string
  ) {}
}
export class createshoppingListItem {
  constructor(
    public food: string,
    public amount: number,
    public unit: string,
    public unitDescription: string,
    public description: string,
    public quickAdd?: string
  ) {}
}
export class createKitchenResponce {
  constructor(
    public kitchen: createKitchenItemResponce[],
    public success: boolean,
    public message_id: number,
    public message: string,
    public statusCode: number
  ) {}
}
export class createshoppingListResponce {
  constructor(
    public shoppingList: createShoppingListItemResponce[],
    public success: boolean,
    public message_id: number,
    public message: string,
    public statusCode: number
  ) {}
}
export class createShoppingListItemResponce {
  constructor(
    public _id: string,
    public food: string,
    public user: string,
    public home: string,
    public unit: string,
    public amount: number,
    public quickAdd: string,
    public unitDescription: string,
    public description: string,
    public expireDate: number,
    public createdAt: string,
    public deleted: boolean,
    public updatedAt: string,
    public groceryCategory: string
  ) {}
}
export class createKitchenItemResponce {
  constructor(
    public groceryCategory: string,
    public user: string,
    public home: string,
    public food: string,
    public unit: string,
    public unitDescription: string,
    public description: string,
    public amount: number,
    public expireDate: number,
    public deleted: boolean,
    public quickAdd: string,
    public _id: string,
    public updatedAt: string,
    public createdAt: string
  ) {}
}
export class getHomeMembers {
  constructor(
    public home: HomeMemberResult,
    public message: string,
    public statusCode: number
  ) {}
}
export class HomeMemberResult {
  constructor(
    public members: HomeMermber[],
    public owner: User,
    public deleted: false,
    public _id: string,
    public updatedAt: string,
    public createdAt: string
  ) {}
}
export class HomeMermber {
  constructor(
    public user: User,
    public _id: string,
    public createdAt: string,
    public updatedAt: string
  ) {}
}
export class kitchenSuggestion {
  constructor(
    public success: boolean,
    public message_id: number,
    public message: string,
    public statusCode: number,
    public count: number,
    public kitchen: cookingStoryPageCategories
  ) {}
}
